// src/services/sale/SaleInvalidationService.ts
import { saleInvalidationApi } from '../../api';
import { SaleInvalidationDTO } from '../../types/sale/invalidation/SaleInvalidationDTO';

/**
 * En el backend las respuestas vienen envueltas en CustomResponse<T>.
 * Aquí devolvemos siempre response.data para mantener el patrón del proyecto.
 */
const SaleInvalidationService = {
    /**
     * Registra una anulación de venta
     * POST /api/sales/invalidation
     */
    register: async (payload: SaleInvalidationDTO) => {
        const response = await saleInvalidationApi.add(payload);
        return response.data; // id de la anulación
    },

    /**
     * Precarga datos base desde una venta
     * GET /api/sales/invalidation/prefill/{saleId}
     */
    getPrefillFromSale: async (saleId: number) => {
        const response = await saleInvalidationApi.fetchCustom(`/prefill/${saleId}`);
        return response.data;
    },

    /**
     * Busca la venta a anular por código de generación
     * GET /api/sales/invalidation/find/target?generationCode=XXXX
     */
    findSaleToInvalidate: async (generationCode: string) => {
        const response = await saleInvalidationApi.fetchCustom(
            `/find/target?generationCode=${encodeURIComponent(generationCode)}`
        );
        return response.data;
    },

    /**
     * Busca la venta de reemplazo por código de generación
     * GET /api/sales/invalidation/find/replacement?generationCode=XXXX
     */
    findReplacementSale: async (generationCode: string) => {
        const response = await saleInvalidationApi.fetchCustom(
            `/find/replacement?generationCode=${encodeURIComponent(generationCode)}`
        );
        return response.data;
    },
};

export default SaleInvalidationService;
